import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthorizationService } from 'src/app/shared/services/authorization.service';
import { Observable } from 'rxjs';



@Injectable()
export class PrivilegeGuard implements Resolve<any>{
    constructor(private authorizationService: AuthorizationService){}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<any>|Promise<any>|any { 

    //Resolve if the parameters are valid
    if(sessionStorage.getItem('podId') && sessionStorage.getItem('podId')!="" &&
        sessionStorage.getItem('engagementId') && sessionStorage.getItem('engagementId')!="" &&
        sessionStorage.getItem('creditorId') && sessionStorage.getItem('creditorId')!=""){
      
        return  this.authorizationService.loadUserRolePrivileges(sessionStorage.getItem('engagementId'),
        sessionStorage.getItem('creditorId'),sessionStorage.getItem('podId'));
    }
    }
}